import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FlexLayoutModule } from '@ngbracket/ngx-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { RouterModule } from '@angular/router'
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask'

import { MaterialModule } from '@shared/material/material.module'
import { WidgetsModule } from '@shared/widgets/widgets.module'
import { PipesModule as ClientPipesModule } from '@app/modules/client/shared/pipes/pipes.module'
import { PipesModule } from '../pipes/pipes.module'
import { FormModule } from '../components/form/form.module'
import { LayoutModule } from '../components/layout/layout.module'
import { ComponentsModule } from '../components/components.module'
import { DirectiveModule } from '../directives/directive.module'

import { UserFormComponent } from '@shared/common-components/user-form/user-form.component'
import { UpdateUserFormComponent } from '@shared/common-components/update-user-form/update-user-form.component'
import { SettingsFormComponent } from './settings/settings.component'
import { ClientUserListComponent } from './client-user-list/client-user-list.component'
import { ClientFormComponent } from './client-form/client-form.component'
import { MapCurrentLocationComponent } from './map-current-location/map-current-location.component'
import { ClientUserDetailsComponent } from './client-user-details/client-user-details.component'
import { StatusHistoryDialogComponent } from '@app/modules/admin/shared/status-history-dialog/status-history-dialog.component'
import { CreateVehicleComponent } from './create-vehicle/create-vehicle.component'
import { CreateUserComponent } from './create-user/create-user.component'
import { EventSectionComponent } from './event-section/event-section.component'
import { DeviceListComponent } from './device-list/device-list.component'
import { DashboardSectionComponent } from './dashboard/dashboard-section.component'
import { DashboardCardComponent } from './dashboard/dashboard-card.component'
import { DashboardCardItemComponent } from './dashboard/dashboard-card-item/dashboard-card-item.component'
import { DashboardCardListComponent } from './dashboard/dashboard-card-list.component'
import { DashboardRatioPeriodsComponent } from './dashboard/dashboard-ratio-periods.component'
import { DriverDocumentListComponent } from './driver-documents/driver-document-list.component'
import { DriverDocumentSaveComponent } from './driver-documents/driver-document-save.component'
import { DocumentRecordsListComponent } from './document-records-list/document-records-list.component'
import { ImportFileComponent } from './import/import-file.component'
import { BadgeComponent } from './badge-component'
import { RemainingProgressBarComponent } from './remaining-progress-bar.component'
import { EditVehicleComponent } from './edit-vehicle/edit-vehicle.component'
import { StickerScheduleComponent } from '@shared/common-components/sticker-schedule/sticker-schedule.component'
import { AvatarComponent } from './avatar/avatar.component'
import { MaintenanceComponent } from './maintenance/maintenance.component'
import { ServiceRecordFormComponent } from './service-record-form/service-record-form.component'
import { ServiceRecordListComponent } from './service-record/service-record-list.component'
import { ServiceRecordNoteDialogComponent } from './service-record/service-record-note-dialog.component'
import { ResellerUserFormComponent } from './reseller-user-form/reseller-user-form.component'
import { PlatformSettingsFormComponent } from './platform-settings-form/platform-settings-form.component'
import { NoteListComponent } from './note-list/note-list.component'
import { ResellerFormComponent } from './reseller-form/reseller-form.component'
import { RecordEditDialogComponent } from './record-edit-dialog/record-edit-dialog.component'
import { DocumentFormComponent } from './documents/document-form.component'
import { ServiceRecordEditDialogComponent } from './service-record-edit-dialog/service-record-edit-dialog.component'
import { AddBecsFormComponent } from './add-becs-form/add-becs-form.component'
import { AddCardFormComponent } from './add-card-form/add-card-form.component'
import { NgxStripeModule } from 'ngx-stripe'
import { DocumentRecordFormComponent } from './documents/document-record-form/document-record-form.component'

@NgModule({
  declarations: [
    UserFormComponent,
    UpdateUserFormComponent,
    SettingsFormComponent,
    ClientUserListComponent,
    ClientFormComponent,
    MapCurrentLocationComponent,
    ClientUserDetailsComponent,
    StatusHistoryDialogComponent,
    CreateVehicleComponent,
    CreateUserComponent,
    EventSectionComponent,
    DeviceListComponent,
    DashboardSectionComponent,
    DashboardCardComponent,
    DashboardCardItemComponent,
    DashboardCardListComponent,
    DashboardRatioPeriodsComponent,
    DocumentFormComponent,
    DocumentRecordFormComponent,
    DriverDocumentListComponent,
    DriverDocumentSaveComponent,
    DocumentRecordsListComponent,
    ImportFileComponent,
    BadgeComponent,
    RemainingProgressBarComponent,
    EditVehicleComponent,
    StickerScheduleComponent,
    AvatarComponent,
    MaintenanceComponent,
    ServiceRecordFormComponent,
    ServiceRecordListComponent,
    ServiceRecordNoteDialogComponent,
    ResellerUserFormComponent,
    PlatformSettingsFormComponent,
    NoteListComponent,
    ResellerFormComponent,
    RecordEditDialogComponent,
    ServiceRecordEditDialogComponent,
    AddBecsFormComponent,
    AddCardFormComponent,
  ],
  exports: [
    UserFormComponent,
    UpdateUserFormComponent,
    SettingsFormComponent,
    ClientUserListComponent,
    ClientFormComponent,
    MapCurrentLocationComponent,
    ClientUserDetailsComponent,
    CreateVehicleComponent,
    CreateUserComponent,
    EventSectionComponent,
    DeviceListComponent,
    DocumentFormComponent,
    DocumentRecordFormComponent,
    DashboardSectionComponent,
    DashboardCardComponent,
    DashboardCardItemComponent,
    DashboardCardListComponent,
    DashboardRatioPeriodsComponent,
    DriverDocumentListComponent,
    DriverDocumentSaveComponent,
    DocumentRecordsListComponent,
    ImportFileComponent,
    BadgeComponent,
    RemainingProgressBarComponent,
    EditVehicleComponent,
    StickerScheduleComponent,
    AvatarComponent,
    MaintenanceComponent,
    ServiceRecordFormComponent,
    ServiceRecordListComponent,
    ServiceRecordNoteDialogComponent,
    ResellerUserFormComponent,
    AvatarComponent,
    PlatformSettingsFormComponent,
    NoteListComponent,
    ResellerFormComponent,
    AddBecsFormComponent,
    AddCardFormComponent,
    NgxStripeModule,
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormModule,
    FormsModule,
    MaterialModule,
    PipesModule,
    ClientPipesModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    WidgetsModule,
    LayoutModule,
    ComponentsModule,
    RouterModule,
    DirectiveModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgxStripeModule.forRoot(),
  ],
  providers: [provideNgxMask()],
})
export class CommonComponentsModule {}
